import { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ managelogin }) => {
  const [isAuth, setIsAuth] = useState(null); // null = loading

  useEffect( () => {
    const handleprotect = async()=>{
     let baseUrl = "";
    if (process.env.NODE_ENV === "production") {
      baseUrl = "https://imw-edu.com/edubackend";
    } else {
      baseUrl = "http://localhost/edubackend";
    }
    const url = `${baseUrl}/session.php`;
    await axios
      .get(url, { withCredentials: true })
      .then((res) => {
        if (res.data.status === 200) {
          setIsAuth(true);
          managelogin(res.data.data);
        } else {
          setIsAuth(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setIsAuth(false);
      });
      }
      handleprotect();
  }, []);

  if (isAuth === null) return <p>Loading...</p>; // or spinner
  if (!isAuth) return <Navigate to="/login" replace />;

  return <Outlet />;
};

export default ProtectedRoute;
